import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner1-1920x450.jpg";
import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { Link } from "react-router-dom";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";
import { useTranslation } from "react-i18next";
import "./ConstitutionPage.scss";

const ConstitutionPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">
            {t("constitution_page_heading")}
          </h1>
          <p className="banner-subtitle">{t("constitution_page_heading2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_constitution_page_link1")}</Link>
        <span>{t("breadcrumbs_constitution_page_span")}</span>
        <Link>{t("breadcrumbs_constitution_page_link2")}</Link>
      </Breadcrumbs>
      <main className="constitution-main-container">
        <section className="constitution-header-section">
          <h2 className="constitution-section-title">
            {t("constitution_page_h4")}
          </h2>
        </section>
        <section className="constitution-content-section">
          <div className="item">
            <Button
              id="toggler"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article1")}
            </Button>
            <UncontrolledCollapse toggler="#toggler">
              <Card>
                <CardBody className={"text-justify"}>
                  {t("constitution_article1_text")}
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler1"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article2")}
            </Button>
            <UncontrolledCollapse toggler="#toggler1">
              <Card>
                <CardBody className={"text-justify"}>
                  <span>{t("constitution_article2_text1")}</span>
                  <ol type="1" className="list">
                    <li>{t("constitution_article2_text2")}</li>
                    <li>{t("constitution_article2_text3")}</li>
                    <li>{t("constitution_article2_text4")}</li>
                    <li>{t("constitution_article2_text5")}</li>
                    <li>{t("constitution_article2_text6")}</li>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler2"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article3")}
            </Button>
            <UncontrolledCollapse toggler="#toggler2">
              <Card>
                <CardBody className={"text-justify"}>
                  <ol className="list">
                    <li>{t("constitution_article3_text1")}</li>
                    <ol type="a">
                      <li>{t("constitution_article3_text2")}</li>
                      <li>{t("constitution_article3_text3")}</li>
                      <li>{t("constitution_article3_text4")}</li>
                      <li>{t("constitution_article3_text5")}</li>
                    </ol>
                    <li>{t("constitution_article3_text6")}</li>
                    <li>{t("constitution_article3_text7")}</li>
                    <ol type="a">
                      <li>{t("constitution_article3_text8")}</li>
                      <li>{t("constitution_article3_text9")}</li>
                    </ol>
                    <li>{t("constitution_article3_text10")}</li>
                    <li>{t("constitution_article3_text11")}</li>
                    <li>{t("constitution_article3_text12")}</li>
                    <ol type="a">
                      <li>{t("constitution_article3_text13")}</li>
                      <li>{t("constitution_article3_text14")}</li>
                    </ol>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler3"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article4")}
            </Button>
            <UncontrolledCollapse toggler="#toggler3">
              <Card>
                <CardBody className={"text-justify"}>
                  <span>{t("constitution_article4_text1")}</span>
                  <ol className="list">
                    <li>{t("constitution_article4_text2")}</li>
                    <ol type="a">
                      <li>{t("constitution_article4_text3")}</li>
                    </ol>
                    <li>{t("constitution_article4_text4")}</li>
                    <ol type="a">
                      <li>{t("constitution_article4_text5")}</li>
                      <li>{t("constitution_article4_text6")}</li>
                    </ol>
                    <li>{t("constitution_article4_text7")}</li>
                    <ol type="a">
                      <li>{t("constitution_article4_text8")}</li>
                      <li>{t("constitution_article4_text9")}</li>
                      <li>{t("constitution_article4_text10")}</li>
                      <li>{t("constitution_article4_text11")}</li>
                      <li>{t("constitution_article4_text12")}</li>
                      <ol type="a">
                        <li>{t("constitution_article4_text13")}</li>
                        <li>{t("constitution_article4_text14")}</li>
                        <li>{t("constitution_article4_text15")}</li>
                      </ol>
                      <li style={{ marginLeft:"2%" }}>{t("constitution_article4_text16")}</li>
                      <li style={{ marginLeft:"2%" }}>{t("constitution_article4_text17")}</li>
                    </ol>
                    <li>{t("constitution_article4_text18")}</li>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler4"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article5")}
            </Button>
            <UncontrolledCollapse toggler="#toggler4">
              <Card>
                <CardBody className={"text-justify"}>
                  <ol className="list">
                    <li>{t("constitution_article5_text1")}</li>
                    <li>{t("constitution_article5_text2")}</li>
                    <li>{t("constitution_article5_text3")}</li>
                    <li>{t("constitution_article5_text4")}</li>
                    <li>{t("constitution_article5_text5")}</li>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler5"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article6")}
            </Button>
            <UncontrolledCollapse toggler="#toggler5">
              <Card>
                <CardBody className={"text-justify"}>
                  <ol className="list">
                    <li>{t("constitution_article6_text1")}</li>
                    <li>{t("constitution_article6_text2")}</li>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler6"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article7")}
            </Button>
            <UncontrolledCollapse toggler="#toggler6">
              <Card>
                <CardBody className={"text-justify"}>
                  <ol className="list">
                    <li>{t("constitution_article7_text1")}</li>
                    <li>{t("constitution_article7_text2")}</li>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler7"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article8")}
            </Button>
            <UncontrolledCollapse toggler="#toggler7">
              <Card>
                <CardBody className={"text-justify"}>
                  <ol className="list">
                    <li>{t("constitution_article8_text1")}</li>
                    <li>{t("constitution_article8_text2")}</li>
                    <li>{t("constitution_article8_text3")}</li>
                    <li>{t("constitution_article8_text4")}</li>
                    <li>{t("constitution_article8_text5")}</li>
                    <ol type="a">
                      <li>{t("constitution_article8_text6")}</li>
                      <li>{t("constitution_article8_text7")}</li>
                      <li>{t("constitution_article8_text8")}</li>
                      <li>{t("constitution_article8_text9")}</li>
                    </ol>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler8"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article9")}
            </Button>
            <UncontrolledCollapse toggler="#toggler8">
              <Card>
                <CardBody className={"text-justify"}>
                  <ol className="list">
                    <li>{t("constitution_article9_text1")}</li>
                    <ol type="a">
                      <li style={{ marginLeft: "10px" }}>
                        {t("constitution_article9_text1a")}
                      </li>
                    </ol>
                    <li>{t("constitution_article9_text2")}</li>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
          <div className="item">
            <Button
              id="toggler9"
              style={{
                marginLeft: "20px",
                marginBottom: "1rem",
                backgroundColor: "white",
                border: "none",
                color: "gray",
                borderLeft: "10px solid #790b1b",
                borderRadius: "0px",
                height: "20px",
                paddingTop: "0px",
                width: "100%",
                textAlign: "start",
              }}
            >
              {t("constitution_article10")}
            </Button>
            <UncontrolledCollapse toggler="#toggler9">
              <Card>
                <CardBody className={"text-justify"}>
                  <ol className="list">
                    <li>{t("constitution_article10_text1")}</li>
                    <li>{t("constitution_article10_text2")}</li>
                  </ol>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </div>
        </section>
      </main>
      <div className="temporary">
        <img id="mlres" src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>
      <Footer />
    </>
  );
};


export default ConstitutionPage;
